import { render, staticRenderFns } from "./eventReg.vue?vue&type=template&id=85a4b67a&"
import script from "./eventReg.vue?vue&type=script&lang=js&"
export * from "./eventReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports